import {
  createMembershipType,
  membeshipsTableResonseType,
  membeshipsTableType,
  updateMembershipType,
} from "@/types";
import { MembershipPlans } from "@/types/member";
import { apiSlice } from "@/redux/apiSlice";

interface membershipInput {
  query?: string;
  org_id: number;
}
export const Memberships = apiSlice.injectEndpoints({
  endpoints(builder) {
    return {
      getMemberships: builder.query<
        membeshipsTableResonseType,
        membershipInput
      >({
        query: (searchCretiria) => ({
          url: `/membership_plan?${searchCretiria.query}`,
          method: "GET",
          headers: {
            Accept: "application/json",
          },
        }),
        providesTags: ["Memberships","Invoice", "Transaction","IncomeCategory","SysConfig"],
      }),
      createMemberships: builder.mutation<any, createMembershipType>({
        query: (membershipsdata) => ({
          url: `/membership_plan`,
          method: "POST",
          body: membershipsdata,
          headers: {
            Accept: "application/json",
          },
        }),
        invalidatesTags: ["Memberships","Invoice", "Transaction","IncomeCategory","SysConfig"],
      }),
      updateMemberships: builder.mutation<any, updateMembershipType>({
        query: (membershipsdata) => ({
          url: `/membership_plan/${membershipsdata.id}`,
          method: "PUT",
          body: membershipsdata,
          headers: {
            Accept: "application/json",
          },
        }),
        invalidatesTags: ["Memberships","Invoice", "Transaction","IncomeCategory","SysConfig"],
      }),
      deleteMemberships: builder.mutation<any, number>({
        query: (membership_id) => ({
          url: `/membership_plan/${membership_id}`,
          method: "DELETE",
          headers: {
            Accept: "application/json",
          },
        }),
        invalidatesTags: ["Memberships","Invoice", "Transaction","IncomeCategory","SysConfig"],
      }),
      getMembershipsById: builder.query<any, number>({
        query: (membership_id) => ({
          url: `/membership_plan/${membership_id}`,
          method: "GET",
          headers: {
            Accept: "application/json",
          },
        }),
        providesTags: ["Memberships","Invoice", "Transaction","IncomeCategory","SysConfig"],
      }),
      getMembershipList: builder.query<MembershipPlans[], void>({
        query: () => ({
          url: `/membership_plan/list/`,
          method: "GET",
          headers: {
            Accept: "application/json",
          },
        }),
        providesTags: ["Memberships","Invoice", "Transaction","IncomeCategory","SysConfig"],
      }),
    };
  },
});

export const {
  useGetMembershipsQuery,
  useCreateMembershipsMutation,
  useUpdateMembershipsMutation,
  useDeleteMembershipsMutation,
  useGetMembershipsByIdQuery,
  useGetMembershipListQuery,
} = Memberships;
